export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge?: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export function useCityCode() {
  const load = async (postalCode: string) => {
    const cepNumbers = postalCode?.replace(/\s/gi, '')?.replace('-', '');
    const response = await fetch(`https://viacep.com.br/ws/${cepNumbers}/json/`);
    const json = (await response.json()) as ViaCepResponse;

    return json.ibge;
  };

  return {
    load,
  };
}
